import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  Damage,
  DamageCreateRequest,
  DamageCreateResponse,
  DamageUpdateRequest,
  DamageUpdateResponse
} from '@ms-organization-entities';
import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {ApiClientConfig} from '../api-client-config';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {ColumnWithLocalization} from "it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization";

@Injectable({
  providedIn: 'root'
})
export class DamageService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/damages/';
  }


  setPriority(id: number, request: PriorityPatchRequest): Observable<Damage> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<Damage>(url, request);
  }


  public getDamages(): Observable<Damage[]> {
    const url = this.endpoint;
    return this.httpClient.get<Damage[]>(url);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  // public updateUserColumns(columnsConfigurationUpsertRequest: ColumnsConfigurationUpsertRequest): Observable<void> {
  //   const url = this.endpoint + 'user-columns';
  //   return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  // }

  public getDamageById(id: number): Observable<Damage> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<Damage>(url);
  }

  public deleteDamage(id: number): Observable<Damage> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<Damage>(url);
  }

  public createDamage(requestBody: DamageCreateRequest): Observable<DamageCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<DamageCreateResponse>(url, requestBody);
  }

  public updateDamage(id: number, requestBody: DamageUpdateRequest): Observable<DamageUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<DamageUpdateResponse>(url, requestBody);
  }

  public getCategories(): Observable<string[]> {
    const url = this.endpoint + 'categories/';
    return this.httpClient.get<string[]>(url);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }

}
